// src/components/NavBar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NavBar.css'; // 為導航條創建樣式

function NavBar() {
  const { t } = useTranslation();

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">{t('site_name')}</Link>
      </div>
      <ul className="navbar-links">
        <li><Link to="/">{t('home_page')}</Link></li>
        <li><Link to="/product">{t('product')}</Link></li>
        <li><Link to="/use-cases">{t('use_cases')}</Link></li>
        <li><Link to="/about-us">{t('about_us.title')}</Link></li>
      </ul>
    </nav>
  );
}

export default NavBar;